

import { IStringMap } from 'app/interfaces/IStringMap';

export type CategoryType = 'Azure' | 'Database' | 'File' | 'GenericProtocol' | 'NoSQL' | 'ServicesApps' | 'Compute' | 'PowerBI' | 'ThirdParty' | 'Workspace' | 'Streaming';
export const connectorCategoryMap: IStringMap<string> = {
    Azure: stringResources.AzureLabel,
    Database: stringResources.Database,
    File: stringResources.File,
    GenericProtocol: stringResources.Dataset_Category_GenericProtocol,
    NoSQL: stringResources.Dataset_Category_NoSQL,
    ServicesApps: stringResources.Dataset_Category_ServiceAndApps,
    PowerBI: stringResources.PowerBI,
    Compute: stringResources.Compute,
    ThirdParty: stringResources.ThirdParty,
    Workspace: stringResources.Workspace
};
export function localizeCategoryType(category: CategoryType): string {
    return connectorCategoryMap[category] != null ? connectorCategoryMap[category] : category.toString();
}
